import { render, staticRenderFns } from "./RelatorioLogUnidadeTematica.vue?vue&type=template&id=6da2f9dc&scoped=true"
import script from "./RelatorioLogUnidadeTematica.vue?vue&type=script&lang=js"
export * from "./RelatorioLogUnidadeTematica.vue?vue&type=script&lang=js"
import style0 from "./RelatorioLogUnidadeTematica.vue?vue&type=style&index=0&id=6da2f9dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da2f9dc",
  null
  
)

export default component.exports